import { ref, computed } from 'vue'

// 로컬스토리지 키
const STORAGE_KEYS = {
  CATEGORIES: 'expense_categories',
  EXPENSES: 'expense_items'
}

// API 요청을 시뮬레이션하는 지연 함수
const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms))

// 스토어 클래스
export class ExpenseStore {
  constructor() {
    // ref를 사용하여 반응형 상태 생성
    this.categories = ref([])
    this.expenses = ref([])
    this.loadFromStorage()
  }

  // 초기 데이터 로드
  loadFromStorage() {
    try {
      const categoriesJson = localStorage.getItem(STORAGE_KEYS.CATEGORIES)
      this.categories.value = categoriesJson ? JSON.parse(categoriesJson) : [
        { id: 1, name: '식비' },
        { id: 2, name: '교통비' },
        { id: 3, name: '주거비' }
      ]

      const expensesJson = localStorage.getItem(STORAGE_KEYS.EXPENSES)
      this.expenses.value = expensesJson ? JSON.parse(expensesJson) : []
    } catch (error) {
      console.error('스토리지 로드 실패:', error)
      this.categories.value = []
      this.expenses.value = []
    }
  }

  // 스토리지 저장
  saveToStorage() {
    try {
      localStorage.setItem(STORAGE_KEYS.CATEGORIES, JSON.stringify(this.categories.value))
      localStorage.setItem(STORAGE_KEYS.EXPENSES, JSON.stringify(this.expenses.value))
    } catch (error) {
      console.error('스토리지 저장 실패:', error)
    }
  }

  // 카테고리 관련 메서드
  async getCategories() {
    return this.categories.value
  }

  async addCategory(name) {
    const newCategory = {
      id: Date.now(),
      name: name.trim()
    }
    this.categories.value.push(newCategory)
    this.saveToStorage()
    return newCategory
  }

  async updateCategory(id, name) {
    const index = this.categories.value.findIndex(c => c.id === id)
    if (index !== -1) {
      this.categories.value[index].name = name.trim()
      this.saveToStorage()
      return this.categories.value[index]
    }
    throw new Error('카테고리를 찾을 수 없습니다')
  }

  async deleteCategory(id) {
    this.categories.value = this.categories.value.filter(c => c.id !== id)
    this.saveToStorage()
  }

  // 지출 내역 관련 메서드
  async getExpenses() {
    return this.expenses.value
  }

  async addExpense(expense) {
    const newExpense = {
      id: Date.now(),
      ...expense,
      amount: Number(expense.amount)
    }
    this.expenses.value.push(newExpense)
    this.saveToStorage()
    return newExpense
  }

  async updateExpense(id, updatedExpense) {
    const index = this.expenses.value.findIndex(e => e.id === id)
    if (index !== -1) {
      this.expenses.value[index] = {
        ...this.expenses.value[index],
        ...updatedExpense,
        amount: Number(updatedExpense.amount)
      }
      this.saveToStorage()
      return this.expenses.value[index]
    }
    throw new Error('지출 내역을 찾을 수 없습니다')
  }

  async deleteExpense(id) {
    this.expenses.value = this.expenses.value.filter(e => e.id !== id)
    this.saveToStorage()
  }
}

// 싱글톤 인스턴스 생성
export const expenseStore = new ExpenseStore() 